const keyboardDatePickerFormActions = {
  deadline: 'Deadline'
};

export default keyboardDatePickerFormActions;
